module.exports = __webpack_public_path__ + "images/empty.b62019ec58c45686671c1838e267b7d4.png";